<template>
    <div></div>
</template>

<script>
    export default {
        name: 'logout',

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            this.$eventHub.$emit('loading', true, 'Aguarde, deslogando da plataforma.')

            this.$store.dispatch('logout').then((response) => {
                this.$router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
            }).catch((response) => {
                this.$router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
            })

            this.$eventHub.$emit('loading', false)
        }
    }
</script>
